import * as z from "zod";
import {
  discountPercentSchema,
  salePaymentLineSchema,
  saleProductLineSchema,
  saleServiceLineSchema,
} from "./sale-checkout-schema";

/** Walk-in start_time is not a form field — POST /api/sales/walk-in stamps
 * salon_now_hhmm() and ignores the client value. */
const walkInServiceLineSchema = saleServiceLineSchema.omit({ start_time: true });

export const walkInSaleSchema = z
  .object({
    discount_percent: discountPercentSchema,
    services: z.array(walkInServiceLineSchema),
    products: z.array(saleProductLineSchema),
    payments: z.array(salePaymentLineSchema).min(1),
  })
  .refine(
    (value) => value.services.length > 0 || value.products.length > 0,
    {
      message: "A sale must have at least one service or product",
      path: ["services"],
    }
  );

export type WalkInSaleFormValues = z.input<typeof walkInSaleSchema>;
export type WalkInSaleParsedValues = z.infer<typeof walkInSaleSchema>;
